var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8473_11944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0799 8.47199L11.9679 5.86399L14.0799 3.25599C14.4479 2.79999 14.5199 2.18399 14.2719 1.65599C14.0239 1.12799 13.4959 0.791992 12.9039 0.791992H3.01591C2.18391 0.791992 1.50391 1.47199 1.50391 2.30399V14.392C1.50391 14.832 1.86391 15.192 2.30391 15.192C2.74391 15.192 3.10391 14.832 3.10391 14.392V10.928H12.9039C13.4959 10.928 14.0159 10.6 14.2719 10.064C14.5279 9.53599 14.4559 8.91999 14.0799 8.46399V8.47199ZM3.10391 9.33599V2.39999H12.7119L10.3119 5.35999C10.0719 5.65599 10.0719 6.07199 10.3119 6.36799L12.7119 9.32799H3.10391V9.33599Z",
    fill: "#FE3F61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8473_11944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagErrorIcon);
export default __webpack_public_path__ + "static/media/flag_error_icon.39c3fc3db375af71378847d2d18a0cc2.svg";
export { ForwardRef as ReactComponent };